// cTrader Open API PayloadTypes
export const PT = {
  HEARTBEAT: 51,
  APP_AUTH_REQ: 2100, APP_AUTH_RES: 2101,
  ACCOUNT_AUTH_REQ: 2102, ACCOUNT_AUTH_RES: 2103,
  TRADER_REQ: 2121, TRADER_RES: 2122,
  RECONCILE_REQ: 2124, RECONCILE_RES: 2125,
  SUBSCRIBE_SPOTS_REQ: 2127,
  SPOT_EVENT: 2131,
  CLOSE_POSITION_REQ: 2111,
  EXECUTION_EVENT: 2126,
  ERROR_RES: 2142,
};

export const SPOT_DIVISOR = 100000;

// All ICMarkets cTrader symbol IDs (102 symbols)
export const SYMBOL_MAP = {
  // Crypto (4)
  BCHUSD: 10028, BTCUSD: 10026, ETHUSD: 10029, LTCUSD: 10030,
  // Forex majors (8)
  EURUSD: 1, GBPUSD: 2, USDJPY: 4, AUDUSD: 5, USDCHF: 6, GBPJPY: 7, USDCAD: 8, EURGBP: 9,
  // Forex crosses (52)
  EURJPY: 3, EURCHF: 10, AUDJPY: 11, NZDUSD: 12, CHFJPY: 13, EURAUD: 14, CADJPY: 15,
  GBPAUD: 16, EURCAD: 17, AUDCAD: 18, GBPCAD: 19, AUDNZD: 20, NZDJPY: 21, USDNOK: 22,
  AUDCHF: 23, USDMXN: 24, GBPNZD: 25, EURNZD: 26, CADCHF: 27, USDSGD: 28, USDSEK: 29,
  NZDCAD: 30, EURSEK: 31, GBPSGD: 32, EURNOK: 33, USDPLN: 35, USDDKK: 36, GBPNOK: 37,
  NZDCHF: 39, GBPCHF: 40,
  USDHKD: 1000, USDZAR: 1001, USDTRY: 1002, NOKSEK: 1003, GBPSEK: 1004, GBPDKK: 1005,
  EURZAR: 1006, EURTRY: 1007, EURSGD: 1008, EURPLN: 1009, EURHKD: 1010, EURDKK: 1011,
  NOKJPY: 1012, SEKJPY: 1013, SGDJPY: 1014, USDHUF: 1015, USDCZK: 1016, AUDSGD: 1017,
  CHFSGD: 1018, USDCNH: 1020, GBPTRY: 10031, USDTHB: 1026,
  // Metals (11)
  XAUUSD: 41, XAGUSD: 42, XAUEUR: 43, XAGEUR: 44, XAUAUD: 10032, XAUCHF: 10047,
  XAUGBP: 10048, XAUJPY: 10049, XAGAUD: 10050, XPDUSD: 10016, XPTUSD: 10017,
  // Energy (3)
  XBRUSD: 10018, XTIUSD: 10019, XNGUSD: 10020,
  // Indices (24)
  STOXX50: 10001, F40: 10002, DE30: 10003, HK50: 10004, IT40: 10005, JP225: 10006,
  AUS200: 10000, UK100: 10011, US2000: 10012, US500: 10013, USTEC: 10014, US30: 10015,
  ES35: 10009, CHINA50: 10025, CA60: 10033, TECDE30: 10034, MIDDE60: 10035, NETH25: 10036,
  SWI20: 10037, CHINAH: 10039, NOR25: 10040, SA40: 10041, SE30: 10042, DE40: 10046,
};

// Default tracked symbols for spot price subscription (crypto)
export const TRACKED_SYMBOLS = {
  BCHUSD: 10028, BTCUSD: 10026, ETHUSD: 10029, LTCUSD: 10030,
};

// Reverse map: symbolId → name (all 102 symbols)
export const SYMBOL_NAMES = Object.fromEntries(
  Object.entries(SYMBOL_MAP).map(([k, v]) => [v, k])
);
